__turbopack_context__.v({
  "navigation": "Navigation-module-scss-module__qD8n8q__navigation",
});
